import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import { isSafariBrowser } from './utilities'

gsap.registerPlugin(ScrollTrigger)

export let spinningDiscs, moveDarts, moveShufflepucks, reduceLogo, revealLogo, bannerParallax

spinningDiscs = () => {
	const medals = document.querySelectorAll('.js-disc')

	medals.forEach((medal) => {
		const img = medal.querySelector('img')

		gsap.to(img, {
			rotate: 180,
			ease: 'linear',
			scrollTrigger: {
				trigger: img,
				start: 'top bottom',
				end: 'bottom top',
				scrub: 0.8
			}
		})
	})
}

moveDarts = () => {
	const darts = document.querySelector('.js-darts')
	const dartSingle = document.querySelectorAll('.js-dart')

	if (!darts) return

	const inner = darts.querySelector('.js-darts-inner')
	const flights = darts.querySelectorAll('.js-dart-flight')

	gsap.fromTo(
		inner,
		{
			xPercent: -10
		},
		{
			scrollTrigger: {
				trigger: darts,
				start: 'top bottom',
				end: 'bottom top',
				scrub: 1.5,
				onUpdate: (self) => {
					if (self.direction == 1) {
						gsap.set(dartSingle, { scaleX: 1 })
					} else {
						gsap.set(dartSingle, { scaleX: -1 })
					}
				}
			},
			xPercent: 0,
			ease: 'linear',
			reversed: true
		}
	)

	gsap.to(flights, {
		scrollTrigger: {
			trigger: darts,
			start: 'top bottom',
			end: 'bottom top',
			scrub: 1.2
		},
		rotateX: 800,
		stagger: 0.008,
		ease: 'power1.inOut'
	})
}

moveShufflepucks = () => {

	let shufflepucks = document.querySelector('.js-shufflepucks')

	if (!shufflepucks) return

	let inner = shufflepucks.querySelector('.js-shufflepucks-inner'),
		items = shufflepucks.querySelectorAll('.js-shufflepuck')

	gsap.fromTo(inner, {
		xPercent: -10
	}, {
		scrollTrigger: {
			trigger: shufflepucks,
			start: 'top bottom',
			end: 'bottom top',
			scrub: true,
		},
		xPercent: 0,
		ease: 'linear',
	})

	gsap.set(items, {
		transformOrigin: 'center',
	})

	gsap.fromTo(items, {
		rotate: '-180deg',
	}, {
		rotate: '0deg',
		ease: 'linear',
		scrollTrigger: {
			trigger: shufflepucks,
			start: 'top bottom',
			end: 'bottom top',
			scrub: true,
		},
	})
}

reduceLogo = () => {
	const timeline = gsap.timeline({
		scrollTrigger: {
			trigger: document.body,
			start: 'top+=200px top',
			toggleActions: 'play none none reverse'
		}
	})
	const logo = document.querySelector('.header__home')
	const logoWords = document.querySelectorAll('.header__word')

	timeline.fromTo(
		logoWords,
		{
			yPercent: 0
		},
		{
			duration: 0.8,
			yPercent: 100,
			stagger: 0.1,
			ease: 'power4.inOut'
		}
	)

	timeline.fromTo(
		logo,
		{
			clipPath: 'inset(0 0rem 0 0)'
		},
		{
			duration: 0.8,
			ease: 'power2.inOut',
			clipPath: window.innerWidth < 650 ? 'inset(0 7.5rem 0 0)' : window.innerWidth < 1024 ? 'inset(0 15rem 0 0)' : 'inset(0 19rem 0 0)',
			overwrite: true
		},
		'<'
	)
}

bannerParallax = () => {
	if (isSafariBrowser()) return

	gsap.to('[data-parallax]', {
		y: (i, el) => (1 - parseFloat(0.4)) * ScrollTrigger.maxScroll(window),
		ease: 'none',
		scrollTrigger: {
			start: 0,
			end: 'max',
			invalidateOnRefresh: true,
			scrub: true
		}
	})
}

export default () => { }
